"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var profile_icon_svg_1 = __importDefault(require("res/img/profile-icon.svg"));
var logout_icon_svg_1 = __importDefault(require("res/img/logout-icon.svg"));
var TopBar = function (_a) {
    var name = _a.name;
    return (react_1.default.createElement("div", { className: 'top-bar flex flex-row flex-space-between' },
        react_1.default.createElement("div", { className: 'top-bar__welcome' },
            react_1.default.createElement("span", null,
                "Welcome ",
                react_1.default.createElement("b", null, name))),
        react_1.default.createElement("div", { className: 'top-bar__nav flex flex-row' },
            react_1.default.createElement(react_router_dom_1.NavLink, { to: '/profile', title: 'Profile', className: 'top-bar__nav__link flex flex-row' },
                react_1.default.createElement("img", { src: profile_icon_svg_1.default, alt: 'Profile' }),
                react_1.default.createElement("span", null, "Profile")),
            react_1.default.createElement(react_router_dom_1.NavLink, { to: '/logout', title: 'Logout', className: 'top-bar__nav__link flex flex-row' },
                react_1.default.createElement("img", { src: logout_icon_svg_1.default, alt: 'Logout' }),
                react_1.default.createElement("span", null, "Logout")))));
};
exports.default = TopBar;
